<div class="dropdown-button" (clickOutside)="showOptions = false" [ngClass]="{'show-selection' : displaySelection}" >
    <div class="dropdown-button-selector" (click)="showOptions = !showOptions" [matTooltip]="tooltip">
        <span class="dropdown-button-selector-icon {{icon}}"></span>
        <span *ngIf="displaySelection" class="dropdown-button-selector-value">{{value?.name}}</span>
        <span class="dropdown-button-selector-arrow" [ngClass]="{'ri-arrow-down-s-fill': !showOptions, 'ri-arrow-up-s-fill': showOptions}"></span>
    </div>
    <div *ngIf="showOptions" class="dropdown-button-values">
        <p [ngClass]="{'highlighted': opt === value}" *ngFor="let opt of options" (click)="selectOption(opt)">{{opt.name}}</p>
    </div>
</div>